// extracted by mini-css-extract-plugin
export default {"chat":"StudentLessonRoom_chat__1k8X0"};